import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { MandatoryParamsGuard } from './modules/core/guards/mandatory-params/mandatory-params.guard';
import { HomeModule } from './modules/home/home.module';
import { ConfirmationStepModule } from './modules/steps/confirmation-step/confirmation-step.module';
import { ProductsStepModule } from './modules/steps/products-step/products-step.module';
import { ServicesStepModule } from './modules/steps/services-step/services-step.module';
import { TravelerDataStepModule } from './modules/steps/traveler-data-step/traveler-data-step.module';
import { WhereWhenStepModule } from './modules/steps/where-when-step/where-when-step.module';
import { BookingMainPageComponent } from './pages/booking-main-page/booking-main-page.component';
import { NotFoundPageComponent } from './pages/not-found-page/not-found-page.component';

const routes: Routes = [
  {
    path: '',
    component: BookingMainPageComponent,
    canActivate: [MandatoryParamsGuard],
    children: [
      {
        path: 'where-when',
        loadChildren: async (): Promise<WhereWhenStepModule> =>
          (
            await import(
              './modules/steps/where-when-step/where-when-step.module'
            )
          ).WhereWhenStepModule,
      },
      {
        path: 'products',
        loadChildren: async (): Promise<ProductsStepModule> =>
          (await import('./modules/steps/products-step/products-step.module'))
            .ProductsStepModule,
      },
      {
        path: 'services',
        loadChildren: async (): Promise<ServicesStepModule> =>
          (await import('./modules/steps/services-step/services-step.module'))
            .ServicesStepModule,
      },
      {
        path: 'traveler-data',
        loadChildren: async (): Promise<TravelerDataStepModule> =>
          (
            await import(
              './modules/steps/traveler-data-step/traveler-data-step.module'
            )
          ).TravelerDataStepModule,
      },
      {
        path: 'confirmation',
        loadChildren: async (): Promise<ConfirmationStepModule> =>
          (
            await import(
              './modules/steps/confirmation-step/confirmation-step.module'
            )
          ).ConfirmationStepModule,
      },
      { path: '', redirectTo: 'products', pathMatch: 'full' },
    ],
  },
  {
    path: 'home',
    loadChildren: async (): Promise<typeof HomeModule> =>
      (await import('./modules/home/home.module')).HomeModule,
  },
  { path: '**', component: NotFoundPageComponent },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'top',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
